import React from "react";

export default function Simple29() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_740_10896)">
        <path
          d="M12 23.5C18.3513 23.5 23.5 18.3513 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5Z"
          fill="#FFCE52"
        />
        <path
          d="M7.5 11C8.32843 11 9 10.1046 9 9C9 7.89543 8.32843 7 7.5 7C6.67157 7 6 7.89543 6 9C6 10.1046 6.67157 11 7.5 11Z"
          fill="#273941"
        />
        <path
          d="M7.5 10.5C8.05228 10.5 8.5 9.82843 8.5 9C8.5 8.17157 8.05228 7.5 7.5 7.5C6.94772 7.5 6.5 8.17157 6.5 9C6.5 9.82843 6.94772 10.5 7.5 10.5Z"
          fill="#141E21"
        />
        <path
          d="M8 9C8.27614 9 8.5 8.77614 8.5 8.5C8.5 8.22386 8.27614 8 8 8C7.72386 8 7.5 8.22386 7.5 8.5C7.5 8.77614 7.72386 9 8 9Z"
          fill="#F6FAFD"
        />
        <path
          d="M11.5 19C8.788 19 6.5 16.85 6.5 15.5H7.5C7.5 16.104 9.1595 18 11.5 18C14.8085 18 17.5 15.5325 17.5 12.5H18.5C18.5 16.084 15.36 19 11.5 19Z"
          fill="#273941"
        />
        <path
          d="M18.2228 11.4143L15.2228 9.41428C15.1498 9.3657 15.091 9.2988 15.052 9.22029C15.0131 9.14179 14.9955 9.05443 15.001 8.96697C15.0064 8.87952 15.0348 8.79504 15.0832 8.72199C15.1316 8.64895 15.1984 8.5899 15.2768 8.55078L18.2768 7.05078L18.7238 7.94578L16.4943 9.06028L18.7778 10.5823L18.2228 11.4143Z"
          fill="#273941"
        />
        <path
          d="M11.9992 1.99911C18.0742 1.99911 22.9992 6.25261 22.9992 11.4991H23.4867C23.3489 8.54514 22.0784 5.7578 19.9392 3.71607C17.7999 1.67434 14.9564 0.535156 11.9992 0.535156C9.04203 0.535156 6.1985 1.67434 4.05927 3.71607C1.92005 5.7578 0.649561 8.54514 0.511719 11.4991H0.999219C0.999219 6.25261 5.92422 1.99911 11.9992 1.99911Z"
          fill="#FFE369"
        />
        <path
          d="M23 11.5C23 16.7465 18.075 21 12 21C5.925 21 1 16.7465 1 11.5H0.5125C0.5055 11.666 0.5 11.8325 0.5 12C0.5 15.05 1.7116 17.9751 3.86827 20.1317C6.02494 22.2884 8.95001 23.5 12 23.5C15.05 23.5 17.9751 22.2884 20.1317 20.1317C22.2884 17.9751 23.5 15.05 23.5 12C23.5 11.8325 23.4945 11.666 23.4875 11.5H23Z"
          fill="#FFB32B"
        />
        <path
          d="M18.9064 4.90641C19.0674 4.74526 19.0162 4.43297 18.7919 4.20889C18.5677 3.98481 18.2553 3.93379 18.0943 4.09494C17.9333 4.25608 17.9845 4.56837 18.2088 4.79246C18.433 5.01654 18.7453 5.06756 18.9064 4.90641Z"
          fill="#F6FAFD"
        />
        <path
          d="M15.5754 2.45108C15.656 2.3704 15.6305 2.21418 15.5184 2.10214C15.4063 1.9901 15.25 1.96467 15.1694 2.04534C15.0888 2.12601 15.1143 2.28223 15.2264 2.39427C15.3386 2.50632 15.4948 2.53175 15.5754 2.45108Z"
          fill="#F6FAFD"
        />
        <path
          d="M17.8134 4.31353C18.1355 3.99123 18.0329 3.36649 17.5842 2.91813C17.1355 2.46977 16.5107 2.36758 16.1886 2.68987C15.8666 3.01217 15.9692 3.63691 16.4179 4.08527C16.8665 4.53363 17.4913 4.63582 17.8134 4.31353Z"
          fill="#F6FAFD"
        />
      </g>
      <defs>
        <clipPath id="clip0_740_10896">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
